import "./App.css";
import { Stage, Layer, Image } from "react-konva";
import useImage from "use-image";
import { useState, useEffect } from "react";
import ReactModal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Import the FontAwesomeIcon component
import {
  faEnvelope,
  faUser,
  faKeyboard,
} from "@fortawesome/free-solid-svg-icons";
import Calendar from "./components/calendar";
import { giveawayData } from "./API/giveaway-api-call.js";
import Konva from "konva";
import CalendarGuide from "./components/calendarGuide";
import { getCalendarData } from "./API/wordpress-api-call";
import WebFont from "webfontloader";

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
ReactModal.setAppElement("#root");
// disables canvas scaling times 4, images might looked blurred on hdpi screens - workaround for "Canvas area exceeds the maximum limit (width * height > 16777216)"
Konva.pixelRatio = 1;

window.dataLayer = window.dataLayer || [];

/* Starting page of the adventskalendar app.
Fetches data like the canvas background and the tuerchen information & sets canvas/stage size and drag boundaries. */
function App() {
  // substract the calendarGuide height
  const [stageSize, setStageSize] = useState({
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight - 96,
  });

  const [canvasImage, setCanvasImage] = useState(
    "#"
  );
  const [canvasWidth, setCanvasWidth] = useState(4000);
  const [canvasHeight, setCanvasHeight] = useState(2250);
  const [calendarColors, setCalendarColors] = useState("");
  const [calendarFontFamily, setCalendarFontFamily] = useState("Roboto");
  const [fontLoaded, setFontLoaded] = useState(false);
  const [giveawayDatenschutz, setGiveawayDatenschutz] = useState("");
  const [giveawayTeilnahme, setGiveawayTeilnahme] = useState("");
  const [giveawayWiderruf, setGiveawayWiderruf] = useState("");
  const [pastTuerchen, setPastTuerchen] = useState({
    status: "",
    heading: "",
    text: "",
  });
  const [futureTuerchen, setFutureTuerchen] = useState({
    status: "",
    heading: "",
    text: "",
  });
  const [tuerchenSVG, setTuerchenSVG] = useState("./assets/brand.svg");

  const initialArray = [];
  const [tuerchen, setTuerchen] = useState(initialArray);

  // changes the size of the stage whenever the window is being resized and get the calendar data from wordpress api on each render
  useEffect(() => {
    let tuerchenData = [];

    const getData = async () => {
      const res = await getCalendarData();
      // check if response is successful and save canvas and tuerchen data to state
      //console.log(res);
      if (res.status === 200) {
        // set the canvas background image, width an height
        // todo: alle state setter bzw. ganze methode in eigene component
        if (
          typeof res.data.background !== "undefined" &&
          res.data.background.image &&
          res.data.background.width &&
          res.data.background.height
        ) {
          setCanvasImage(res.data.background.image);
          setCanvasWidth(res.data.background.width);
          setCanvasHeight(res.data.background.height);

          // set the calendar colors
          if (
            typeof res.data.modalColors !== "undefined" &&
            res.data.modalColors.modalBackground &&
            res.data.modalColors.colorPrimary &&
            res.data.modalColors.colorSecondary &&
            res.data.modalColors.colorTertiary &&
            res.data.modalColors.colorHighlight &&
            res.data.modalColors.fontColorText
          ) {
            document
              .querySelector(":root")
              .style.setProperty("--text", res.data.modalColors.fontColorText);
            const textColorWithOpacity =
              res.data.modalColors.fontColorText + "cc";
            document
              .querySelector(":root")
              .style.setProperty("--text-80", textColorWithOpacity);
            document
              .querySelector(":root")
              .style.setProperty(
                "--modal-background",
                res.data.modalColors.modalBackground
              );
            document
              .querySelector(":root")
              .style.setProperty(
                "--brand-primary",
                res.data.modalColors.colorPrimary
              );
            document
              .querySelector(":root")
              .style.setProperty(
                "--brand-secondary",
                res.data.modalColors.colorSecondary
              );
            document
              .querySelector(":root")
              .style.setProperty(
                "--brand-tertiary",
                res.data.modalColors.colorTertiary
              );
            const colorTertiaryWithOpacity =
              res.data.modalColors.colorTertiary + "a3";
            document
              .querySelector(":root")
              .style.setProperty(
                "--brand-tertiary-64",
                colorTertiaryWithOpacity
              );
            document
              .querySelector(":root")
              .style.setProperty(
                "--edel-red",
                res.data.modalColors.colorHighlight
              );
            const colorHightlightWithOpacity =
              res.data.modalColors.colorHighlight + "52";
            document
              .querySelector(":root")
              .style.setProperty("--edel-red-32", colorHightlightWithOpacity);
          }

          // safe colors to send them to calendar.js
          setCalendarColors({
            modalBackground: res.data.modalColors.modalBackground,
            colorPrimary: res.data.modalColors.colorPrimary,
            colorSecondary: res.data.modalColors.colorSecondary,
            colorTertiary: res.data.modalColors.colorTertiary,
            colorHighlight: res.data.modalColors.colorHighlight,
            fontColorText: res.data.modalColors.fontColorText,
          });
        }

        // set the font family from API to the font state and use it via webfontloader/useEffect
        // "Chilanka" for testing fonts
        if (typeof res.data.fontFamily !== "undefined" && res.data.fontFamily) {
          setCalendarFontFamily(res.data.fontFamily);
          document
            .querySelector(":root")
            .style.setProperty("--font", res.data.fontFamily);
        }

        // set the links for Datenschutz, Teilnahmebedingung and Widerruf
        if (
          typeof res.data.giveawayDatenschutz !== "undefined" &&
          res.data.giveawayDatenschutz &&
          res.data.giveawayTeilnahmebedingungen &&
          res.data.giveawayWiderruf
        ) {
          setGiveawayDatenschutz(res.data.giveawayDatenschutz);
          setGiveawayTeilnahme(res.data.giveawayTeilnahmebedingungen);
          setGiveawayWiderruf(res.data.giveawayWiderruf);
        }

        // set the status for expired and future tuerchen
        if (
          typeof res.data.modalPastStatus !== "undefined" &&
          typeof res.data.modalFutureStatus !== "undefined" &&
          res.data.modalPastStatus &&
          res.data.modalFutureStatus
        ) {
          setPastTuerchen((oldState) => ({
            ...oldState,
            status: res.data.modalPastStatus,
          }));
          setFutureTuerchen((oldState) => ({
            ...oldState,
            status: res.data.modalFutureStatus,
          }));
        }
        // set the headings for expired and future tuerchen
        if (
          typeof res.data.modalPastHeading !== "undefined" &&
          typeof res.data.modalFutureHeading !== "undefined" &&
          res.data.modalPastHeading &&
          res.data.modalFutureHeading
        ) {
          setPastTuerchen((oldState) => ({
            ...oldState,
            heading: res.data.modalPastHeading,
          }));
          setFutureTuerchen((oldState) => ({
            ...oldState,
            heading: res.data.modalFutureHeading,
          }));
        }

        // set the texts for expired and future tuerchen
        if (
          typeof res.data.modalPastText !== "undefined" &&
          typeof res.data.modalFutureText !== "undefined" &&
          res.data.modalPastText &&
          res.data.modalFutureText
        ) {
          setPastTuerchen((oldState) => ({
            ...oldState,
            text: res.data.modalPastText,
          }));
          setFutureTuerchen((oldState) => ({
            ...oldState,
            text: res.data.modalFutureText,
          }));
        }

        // set the svg of the present tuerchen's modal header
        if (
          typeof res.data.tuerchenSVG !== "undefined" &&
          res.data.tuerchenSVG
        ) {
          setTuerchenSVG(res.data.tuerchenSVG);
        }

        // save tuerchen data to state
        for (let i = 0; i < res.data.tuerchen.length; i++) {
          tuerchenData.push(res.data.tuerchen[i]);
        }
        setTuerchen(tuerchenData);
      } else {
        // handle error
        console.log("Fehler bei der Abfrage des Canvas Hintergrundes");
      }
    };
    getData();
    const checkSize = () => {
      setStageSize({
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight - 96,
      });
    };
    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, []);

  // safe font with webfontloader. Update CSS with new font.
  // todo: alle variablen aus dem plugin-editor in den localStorage, sodass nur einmal geladen werden muss?
  useEffect(() => {
    // families is an array, but we should only need one font family at a time / per calender app
    /* WebFont.load({
      google: {
        families: [calendarFontFamily],
      },
      fontactive: function () {
        //when fonts loaded call this function
        setTimeout(() => {
          setFontLoaded(true);
        }, 100);
      },
    }); */
    // eslint ignore next line
  }, [calendarFontFamily]);

  // use the background image for the canvas
  const BackgroundImage = () => {
    // "./images/canvas-background.jpg" / canvasImage
    const background = canvasImage;
    const [image] = useImage(background);
    return (
      <Image
        width={canvasWidth}
        height={canvasHeight}
        image={image}
        x={0}
        y={0}
      />
    );
  };

  /* calculate the scaling (zoom level) of the stage content: mobile devices zoom out further to
  have a better overview of the canvas */
  // 1.0(>1)  0.75(<1 & >0.5) 0.5(<0.5)
  let scale = stageSize.width / 1000;
  let textSize = 40;
  if (scale > 1.1) {
    scale = 1.0;
  } else if (scale < 1.1 && scale > 0.6) {
    scale = 0.7;
    textSize = 48;
  } else if (scale < 0.6) {
    scale = 0.5;
    textSize = 56;
  }

  const divStyle = {
    width: stageSize.width,
    height: stageSize.height,
    overflow: "hidden",
    margin: "0 auto",
  };

  /* set x, y bondary-coordinates in dragBoundFunc to only scroll over visible background canvas.
 (otherwise you could scroll infinitely in every direction).  */
  // bottom right corner
  const dragBoundaryMaxX = stageSize.width - canvasWidth * scale;
  const dragBoundaryMaxY = stageSize.height - canvasHeight * scale;
  // top left corner
  const dragBoundaryMinX = 0;
  const dragBoundaryMinY = 0;

  // modal state (mobile version -> muss stage maße auch ändern für mobile?)
  const [showModal, setShowModal] = useState(false);
  const [modalDay, setModalDay] = useState("");
  const [modalIntro, setModalIntro] = useState("");
  const [modalHeading, setModalHeading] = useState("");
  const [modalFormHeading, setModalFormHeading] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [modalGiveawayTitle, setModalGiveawayTitle] = useState("");
  const [modalShortDescription, setModalShortDescription] = useState("");
  const [modalQuizQuestion, setModalQuizQuestion] = useState("");
  const [modalQuizAnswers, setModalQuizAnswers] = useState([]);
  const [modalQuizSolution, setModalQuizSolution] = useState([]);
  const [modalImage, setModalImage] = useState("");
  const [modalVideo, setModalVideo] = useState("");
  const [modalTime, setModalTime] = useState("");
  const [modalShowGiveaway, setModalShowGiveaway] = useState("");
  const [message, setMessage] = useState("");
  const [displayForm, setDisplayForm] = useState(true);

  /* submits the users form data to api endpoint*/
  const handleSubmit = (event) => {
  event.preventDefault(); // Verhindert das Standardverhalten des Formulars

  const thisFirstname = event.target.fname.value || "";
  const thisLastname = event.target.lname.value || "";
  const thisEmail = event.target.email.value || "";
  const thisDay = modalDay || "";
  const thisNewsletter =  !!event.target.newsletter.checked;
  let thisAnswer = "";

  // Überprüfen, ob es eine Quizfrage gibt
  if (modalQuizQuestion) {
    if (modalQuizAnswers.length > 0) {
      // Wenn es Antwortoptionen gibt, den Wert des ausgewählten Radios abrufen
      thisAnswer = event.target.quiz ? event.target.quiz.value : "";
    } else {
      // Wenn es keine Antwortoptionen gibt, den Wert des Eingabefelds abrufen
      thisAnswer = event.target.giveawayAnswer ? event.target.giveawayAnswer.value : "";
    }
  }

  const thisCorrect = modalQuizSolution || "";

  // Senden der Daten an die API
  const formData = async () => {
    window.dataLayer.push({
      event: "form_submitted",
      firstname: thisFirstname,
      lastname: thisLastname,
      mail: thisEmail,
      day: thisDay,
      answer: thisAnswer,

    });

    const res = await giveawayData(
      thisFirstname,
      thisLastname,
      thisEmail,
      thisDay,
      thisAnswer,
      thisCorrect,
      thisNewsletter
    );

    if (res === 200) {
      // Erfolgreiche Übermittlung
      setMessage("Deine Antwort wurde versendet - viel Glück!");
    } else {
      // Fehler bei der Übermittlung
      setMessage("Da ist leider etwas schiefgelaufen - versuche es später nochmal...");
    }
  };

  formData();
  setDisplayForm(false);
};

  /* Open modal and set all states of the modal content */
  const handleOpenModal = (
    day,
    intro,
    modalHeading,
    formHeading,
    description,
    giveawayTitle,
    shortDescription,
    quizQuestion,
    quizAnswers,
    correct,
    image,
    video,
    time,
    showGiveaway
  ) => {
    setShowModal(true);
    // check if day is < 10 - add leading 0 if true
    if (day < 10) {
      const newDigit = "0" + day;
      setModalDay(newDigit);
    } else {
      setModalDay(day);
    }

    setModalIntro(intro);
    setModalHeading(modalHeading);
    setModalFormHeading(formHeading);
    setModalDescription(description);
    setModalGiveawayTitle(giveawayTitle);
    setModalShortDescription(shortDescription);
    setModalQuizQuestion(quizQuestion);
    setModalQuizAnswers(quizAnswers);
    setModalQuizSolution(correct);
    setModalImage(image);
    setModalVideo(video);
    setModalTime(time);
    setModalShowGiveaway(showGiveaway);
  };

  // closes the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setMessage("");
    setDisplayForm(true);
  };

  let media;
  let videoImage;
  if (modalVideo && modalImage) {
    media = (
      <iframe
        title="YouTube video player"
        width="800"
        height="450"
        uc-src={modalVideo}
        src={modalVideo}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      ></iframe>
    );
    videoImage = <img src={modalImage} alt={modalGiveawayTitle} width="800" />;
  } else if (modalImage) {
    media = <img src={modalImage} alt={modalGiveawayTitle} width="800" />;
  }

  // message that gets displayed after submitting the form
  let displayMessage;
  if (message) {
    displayMessage = (
      <div className="giveaway_message font-roboto-s-brand-primary-bold">
        {message}
      </div>
    );
  }

  let modal;
  let giveawayForm;
  let giveawayQuiz;

  // if question and answers empty, don't display anything
  if (!modalQuizQuestion && !modalQuizAnswers) {
    giveawayQuiz = (
      <div className="giveaway_form-radio">
        <div className="font-roboto-m-brand-primary-bold giveaway_form-question">
          {/* {modalFormHeading} */}
        </div>
      </div>
    );
    // if question is there but not answer options, show an input field to answer the questions
  } else if (modalQuizQuestion && !modalQuizAnswers) {
    giveawayQuiz = (
      <>
        <div className="giveaway_form-radio">
          <div className="font-roboto-m-brand-primary-bold giveaway_form-question">
            {modalFormHeading}
          </div>
          <p className="font-roboto-xs-white">{modalQuizQuestion}</p>
        </div>
        <div className="giveaway_field-mail">
          <label
            className="font-roboto-s-brand-primary-bold"
            htmlFor="giveawayAnswer"
          >
            Antwort
          </label>
          <div className="giveaway_field-input">
            <FontAwesomeIcon icon={faKeyboard} size="sm"></FontAwesomeIcon>
            <input
              type="text"
              id="giveawayAnswer"
              name="giveawayAnswer"
              placeholder="Deine Antwort"
              required
            />
            <div className="font-roboto-xxs-brand-tertiary giveaway_field-required">
              Pflichtfeld
            </div>
          </div>
        </div>
      </>
    );
    // if question and answers are there
  } else {
    giveawayQuiz = (
      <>
        <div className="font-roboto-m-brand-primary-bold giveaway_form-question">
          {modalFormHeading}
        </div>
        <p className="font-roboto-xs-white">{modalQuizQuestion}</p>
        {modalQuizAnswers.map((answer, index) => (
          <div className="giveaway_form-radio" key={answer + index}>
            <input
              type="radio"
              id={answer}
              name="quiz"
              value={answer}
              defaultChecked
            />
            <label className="font-roboto-xs-white-bold" htmlFor={answer}>
              {answer}
            </label>
          </div>
        ))}
      </>
    );
  }

  if (displayForm) {
    giveawayForm = (
      <form onSubmit={handleSubmit}>
        <div className="giveaway_form">{giveawayQuiz}</div>
        <div className="giveaway_form">
          <div className="giveaway_field_row">
            <div className="giveaway_field">
              <label
                className="font-roboto-s-brand-primary-bold"
                htmlFor="fname"
              >
                Vorname
              </label>
              <div className="giveaway_field-input">
                <FontAwesomeIcon icon={faUser} size="sm"></FontAwesomeIcon>
                <input
                  type="text"
                  id="fname"
                  name="fname"
                  placeholder="Max"
                  required
                />
                <div className="font-roboto-xxs-brand-tertiary giveaway_field-required">
                  Pflichtfeld
                </div>
              </div>
            </div>
            <div className="giveaway_field">
              <label
                className="font-roboto-s-brand-primary-bold"
                htmlFor="lname"
              >
                Nachname
              </label>
              <div className="giveaway_field-input">
                <FontAwesomeIcon icon={faUser} size="sm"></FontAwesomeIcon>
                <input
                  type="text"
                  id="lname"
                  name="lname"
                  placeholder="Mustermann"
                  required
                />
                <div className="font-roboto-xxs-brand-tertiary giveaway_field-required">
                  Pflichtfeld
                </div>
              </div>
            </div>
          </div>
          <div className="giveaway_field-mail">
            <label className="font-roboto-s-brand-primary-bold" htmlFor="email">
              E-Mail Adresse
            </label>
            <div className="giveaway_field-input">
              <FontAwesomeIcon icon={faEnvelope} size="sm"></FontAwesomeIcon>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="ich@beispiel.de"
                required
              />
              <div className="font-roboto-xxs-brand-tertiary giveaway_field-required">
                Pflichtfeld
              </div>
            </div>
          </div>
          {/*
          <div className="giveaway_field_row">
            <div className="giveaway_datenschutz">
              <input
                type="checkbox"
                id="datenschutz"
                name="datenschutz"
                required
              />
              <div className="font-roboto-xxs-brand-tertiary">
                Hiermit bestätige ich meine Teilnahme am Gewinnspiel und stimme
                den{" "}
                <a
                  href={giveawayTeilnahme}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="font-roboto-xxs-brand-primary">
                    Teilnahmebedingungen
                  </span>{" "}
                </a>
                zu.
              </div>
            </div>
          </div>
          */}
          <div className="giveaway_field_row" style={{ marginBottom: 20 }}>
            <div className="giveaway_datenschutz">
              <input
                type="checkbox"
                id="datenschutzTeilnahme"
                name="datenschutzTeilnahme"
                required
              />
              <div className="font-roboto-xxs-brand-tertiary">
                Hiermit bestätige ich meine Teilnahme am Gewinnspiel. Ich stimme
                den <a href={giveawayTeilnahme} target="_blank" rel="noopener noreferrer"><span className="">Teilnahmebedingungen</span></a> zu und habe die <a href={giveawayDatenschutz} target="_blank" rel="noopener noreferrer"><span className="">Datenschutzerklärung</span></a> zur Kenntnis genommen. Ich willige außerdem ein, dass Edel meine personenbezogenen Daten zum Zwecke der Abwicklung des Gewinnspiels speichert und verarbeitet. Ein Widerruf ist zu richten an: <a href="mailto:onlinemarketing@edel.com"><span>onlinemarketing@edel.com</span></a>.
              </div>
            </div>
          </div>

          <div className="giveaway_field_row">
            <div className="giveaway_datenschutz">
              <input
                type="checkbox"
                id="newsletter"
                name="newsletter"

              />
              <div className="font-roboto-xxs-brand-tertiary">
                Optional: Ja, ich möchte den Newsletter erhalten und über Neuigkeiten
                informiert werden. Ich stimme der Verarbeitung meiner
                Kontaktdaten zu und nehme die{" "}
                <a
                  href={giveawayDatenschutz}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="">
                    Datenschutzerklärung
                  </span>{" "}
                </a>{" "}
                zur Kenntnis. Eine Abmeldung vom Newsletter über den Link im
                Footer oder ein{" "}
                <a
                  href={giveawayWiderruf}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="">
                    Widerruf
                  </span>{" "}
                </a>{" "}
                meiner Einwilligung ist jederzeit möglich.
              </div>
            </div>
          </div>

          <div className="giveaway_field-submit">
            <button type="submit">Jetzt an der Verlosung teilnehmen</button>
          </div>
        </div>
      </form>
    );
  }
  // show the modal depending on if its in the past, present or future
  switch (modalTime) {
    case "present":


    window.dataLayer.push({
      event: "opening_present_modal",
      day: {modalDay}
    });

      modal = (
        <ReactModal
          isOpen={showModal}
          contentLabel="Modal mit Türchen"
          className="Modal"
          overlayClassName="Overlay"
          onRequestClose={
            () => handleCloseModal()
            /* Function that will be run when the modal is requested
        to be closed (either by clicking on overlay or pressing ESC).
        Note: It is not called if isOpen is changed by other means. */
          }
        >
          <div>
            <div className="giveaway_header">
              <div className="giveaway_header-img">
                <img src={tuerchenSVG} alt="Branding SVG" />
              </div>
              <div className="font-roboto-xl-brand-secondary giveaway_header-door">
                {/* {modalDay} */}
              </div>
              <button
                className="giveaway_header-close"
                onClick={() => handleCloseModal()}
              >
                <img
                  src="./assets/close.svg"
                  alt="Krimikollegen Adventskalender"
                  width="428"
                  height="76"
                />
              </button>
            </div>
            <div className="giveaway_present-img">{media}</div>
            <div className="giveaway_form">
              <div className="font-roboto-l-brand-primary-bold giveaway_form-day">
                {modalHeading} {modalDay}
              </div>
              <div className="font-roboto-xs-white font-line-height-200">
                {modalIntro}
              </div>
              <div className="font-roboto-s-white-bold giveaway_form-title">
                {modalGiveawayTitle}
              </div>
              <div
                className="font-roboto-xs-white font-line-height-200"
                dangerouslySetInnerHTML={{ __html: modalDescription }}
              ></div>
            </div>
            {modalShowGiveaway ? giveawayForm : null}
            {displayMessage}
          </div>
        </ReactModal>
      );
      break;
    case "past":

    window.dataLayer.push({
      event: "opening_past_modal",
      day: {modalDay}
    });


    modal = (
        <ReactModal
          isOpen={showModal}
          contentLabel="Modal mit Türchen"
          className="Modal"
          overlayClassName="Overlay"
          onRequestClose={
            () => handleCloseModal()
            /* Function that will be run when the modal is requested
        to be closed (either by clicking on overlay or pressing ESC).
        Note: It is not called if isOpen is changed by other means. */
          }
        >
          <div className="giveaway_expired">
            <div className="giveaway_expired-header">
              <div>
                <div className="font-roboto-ml-edel-red">
                  {pastTuerchen.status}
                </div>
                <div className="font-roboto-l2-brand-primary">
                  {pastTuerchen.heading}
                </div>
              </div>
              <button
                className="giveaway_expired-close"
                onClick={() => handleCloseModal()}
              >
                <img
                  src="./assets/close.svg"
                  alt="Krimikollegen Adventskalender"
                  width="428"
                  height="76"
                />
              </button>
            </div>
            <div
              className="font-roboto-xs-white font-line-height-200 giveaway_expired-text"
              dangerouslySetInnerHTML={{ __html: pastTuerchen.text }}
            ></div>
          </div>
          <div className="giveaway_expired-img">
            {modalVideo && modalImage ? videoImage : media}
            <div className="giveaway_expired-overlay"> </div>
          </div>
          <div className="giveaway_expired">
            <div className="font-roboto-s-white-bold">{modalGiveawayTitle}</div>
            <div className="font-roboto-xs-white font-line-height-120-m">
              {modalShortDescription}
            </div>
          </div>
        </ReactModal>
      );
      break;
    case "future":

    window.dataLayer.push({
      event: "opening_future_modal",
      day: {modalDay}
    });


      modal = (
        <ReactModal
          isOpen={showModal}
          contentLabel="Modal mit Türchen"
          className="Modal"
          overlayClassName="Overlay"
          onRequestClose={
            () => handleCloseModal()
            /* Function that will be run when the modal is requested
        to be closed (either by clicking on overlay or pressing ESC).
        Note: It is not called if isOpen is changed by other means. */
          }
        >
          <div className="giveaway_expired">
            <div className="giveaway_expired-header">
              <div>
                <div className="font-roboto-ml-edel-red">
                  {futureTuerchen.status}
                </div>
                <div className="font-roboto-l2-brand-primary">
                  {futureTuerchen.heading}
                </div>
              </div>
              <button
                className="giveaway_expired-close"
                onClick={() => handleCloseModal()}
              >
                <img
                  src="./assets/close.svg"
                  alt="Krimikollegen Adventskalender"
                  width="428"
                  height="76"
                />
              </button>
            </div>
            <div
              className="font-roboto-xs-white font-line-height-200 giveaway_expired-text"
              dangerouslySetInnerHTML={{ __html: futureTuerchen.text }}
            ></div>
          </div>
        </ReactModal>
      );
      break;
    default:
    // default
  }

  return (
    <>
      <div>
        <CalendarGuide />
      </div>
      <div>{modal}</div>
      <div style={divStyle}>
        <Stage
          width={stageSize.width}
          height={stageSize.height}
          scaleX={scale}
          scaleY={scale}
          draggable
          dragBoundFunc={(pos) => {
            let newX =
              pos.x < dragBoundaryMaxX
                ? dragBoundaryMaxX
                : pos.x > dragBoundaryMinX
                ? dragBoundaryMinX
                : pos.x;
            let newY =
              pos.y < dragBoundaryMaxY
                ? dragBoundaryMaxY
                : pos.y > dragBoundaryMinY
                ? dragBoundaryMinY
                : pos.y;
            return {
              x: newX,
              y: newY,
            };
          }}
        >
          {/* Layer for static shapes (e.g. background) */}
          <Layer>
            <BackgroundImage />
          </Layer>
          {/* Layer for shapes/tuerchen on background */}
          <Calendar
            handleOpenModal={handleOpenModal}
            scaleText={textSize}
            tuerchenData={tuerchen}
            calendarColors={calendarColors}
            fontFamily={calendarFontFamily}
            loaded={fontLoaded}
          ></Calendar>
        </Stage>
      </div>
    </>
  );
}

export default App;
